import type * as React from 'react';

export interface IAnimationDetailGridProps {
  children: React.ReactElement[];
}
